define([
	"dojo/_base/declare",
	"csi/heading/AggregateController",
	"csi/page",
	"csi/state/rootStore",
	"csi/xml",
	"csi/widget/MessageDialog"
], function(declare, AggregateController, page, {routerStore}, xml, MessageDialog) {

	return declare(AggregateController, {
		getConfirmButton: function() {
			return MessageDialog.BUTTON_CHANGE;
		},

		publish: function() {
			// summary: confirm action before continuing
			if (xml.isValidURL(this.getNode().__Parent__)) {
				this.confirmAction();
			} else {
				this.inherited(arguments);
			}
		},

		onConfirm: function(/*String*/key) {
			// summary: if configured to confirm action, then start now that confirmed
			if (key == MessageDialog.BUTTON_CHANGE) {
				AggregateController.prototype.publish.call(this);
			} else {
				this.postProcess();
			}
		},

		postProcessSuccess: function() {
			// summary: if material is in breadcrumb trail, then refresh all views
			if (routerStore.locationUrl == this.m_urlNode) {
				page.refreshViews();
			} else {
				this.inherited(arguments);
			}
		}
	});
});